import { required, maxLength, numeric, minLength, email } from 'vuelidate/lib/validators'

const regexOperador = value => {
  if (typeof value === 'undefined' || value === null || value === '') {
    return true
  }
  return /^[a-zA-Z0-9\s]+$/g.test(value)
}

export const validateData = {
  form: {
    numero: { required, minLength: minLength(3), maxLength: maxLength(10), numeric },
    usuario: { required, maxLength: maxLength(20), regexOperador },
    email: { required, email },
    senhaRamal: { required, numeric, minLength: minLength(4) },
    maxlen: { required, numeric, maxLength: maxLength(2) },
    rota: { required },
    rotaTransferencia: { required },
    departamento: { required },
  },
}

export const validateComputed = {
  numeroErrors() {
    const errors = []
    if (!this.$v.form.numero.$dirty) return errors
    !this.$v.form.numero.maxLength && errors.push('Código não pode ter mais de 10 dígitos')
    !this.$v.form.numero.minLength && errors.push('Código não pode ter menos de 3 dígitos')
    !this.$v.form.numero.required && errors.push('Código é obrigatório.')
    !this.$v.form.numero.numeric && errors.push('Apenas caracteres numéricos são válidos.')
    return errors
  },
  usuarioErrors() {
    const errors = []
    if (!this.$v.form.usuario.$dirty) return errors
    !this.$v.form.usuario.maxLength && errors.push('Usuário não pode ter mais de 20 dígitos')
    !this.$v.form.usuario.required && errors.push('Usuário é obrigatório.')
    !this.$v.form.usuario.regexOperador && errors.push('Apenas letras, números e espaço.')
    return errors
  },
  emailErrors() {
    const errors = []
    if (!this.$v.form.email.$dirty) return errors
    !this.$v.form.email.required && errors.push('E-mail é obrigatório.')
    !this.$v.form.email.email && errors.push('E-mail inválido.')
    return errors
  },
  senhaRamalErrors() {
    const errors = []
    if (!this.$v.form.senhaRamal.$dirty) return errors
    !this.$v.form.senhaRamal.required && errors.push('Senha é obrigatória.')
    !this.$v.form.senhaRamal.numeric && errors.push('Apenas números.')
    !this.$v.form.senhaRamal.minLength && errors.push('Senha deve conter ao menos 4 dígitos.')
    return errors
  },
  rotaErrors() {
    const errors = []
    if (!this.$v.form.rota.$dirty) return errors
    !this.$v.form.rota.required && errors.push('Escolha pelo menos uma rota.')
    return errors
  },
  departamentoErrors() {
    const errors = []
    if (!this.$v.form.departamento.$dirty) return errors
    !this.$v.form.departamento.required && errors.push('Escolha pelo menos um departamento.')
    return errors
  },
  rotaTransferenciaErrors() {
    const errors = []
    if (!this.$v.form.rotaTransferencia.$dirty) return errors
    !this.$v.form.rotaTransferencia.required && errors.push('Escolha pelo menos uma rota de transferência.')
    return errors
  },
  maxlenErrors() {
    const errors = []
    if (!this.$v.form.maxlen.$dirty) return errors
    !this.$v.form.maxlen.required && errors.push('Campo obrigatório.')
    !this.$v.form.maxlen.numeric && errors.push('Apenas caracteres numéricos.')
    !this.$v.form.maxlen.maxLength && errors.push('Máximo: 99.')
    return errors
  },
}
